// The ONE selection grip: every draggable handle in every space — the model, a
// generated section, a sheet's objects and viewports, the title-block editor —
// is painted by `drawGrip`, so a grip looks the same wherever it is and a new
// kind of handle cannot invent a fourth style. DOM-free (canvas calls only), so
// section.ts, which the unit tests bundle, can use it too.

import type { Vec2 } from '../shared/types';

/** Side of a grip square, in screen px. */
export const GRIP_PX = 8;
/** How far from a grip's centre a press still grabs it, in screen px. */
export const GRIP_HIT_PX = 9;
/** A grip's normal fill. Other fills mark a STATE, never a different space:
 *  green = a vertex being edited, blue = the selected vertex. */
export const GRIP_FILL = '#ffd166';
/** A connection end GLUED to an object (PowerPoint's green end); a free end keeps
 *  the normal fill. */
export const GRIP_GLUED = '#3ecf6e';
/** The grip being worked: a selected vertex, a handle being dragged or armed. */
export const GRIP_SELECTED = '#4aa3ff';
export const GRIP_STROKE = '#1e1f24';

/** One grip centred on the screen point `p`. */
export function drawGrip(ctx: CanvasRenderingContext2D, p: Vec2, fill: string = GRIP_FILL): void {
  const h = GRIP_PX / 2;
  ctx.save();
  ctx.setLineDash([]);
  ctx.fillStyle = fill;
  ctx.strokeStyle = GRIP_STROKE;
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.rect(p.x - h, p.y - h, GRIP_PX, GRIP_PX);
  ctx.fill();
  ctx.stroke();
  ctx.restore();
}

/** A grip at each screen point. */
export function drawGrips(ctx: CanvasRenderingContext2D, pts: readonly Vec2[], fill: string = GRIP_FILL): void {
  for (const p of pts) drawGrip(ctx, p, fill);
}
